import { gql } from "@apollo/client";

export const GET_SAVED_VIEWS = gql`
  query GetSavedViews(
    $courierId: ID!
    $userOrEmployeeId: ID!
    $page: SavedViewPage!
  ) {
    savedViews(
      courierId: $courierId
      userOrEmployeeId: $userOrEmployeeId
      page: $page
    ) {
      id
      courierId
      userOrEmployeeId
      page
      name
      primaryFilter
      filters {
        key
        values
      }
      sortFields {
        sortBy
        direction
      }
      isDefault
      createdAt
    }
  }
`;

export const CREATE_SAVED_VIEW = gql`
  mutation CreateSavedView(
    $courierId: ID!
    $userOrEmployeeId: ID!
    $page: SavedViewPage!
    $name: String!
    $primaryFilter: String
    $filters: [SavedViewFilterInput!]!
    $sortFields: [SavedViewSortInput!]!
  ) {
    createSavedView(
      courierId: $courierId
      userOrEmployeeId: $userOrEmployeeId
      page: $page
      name: $name
      primaryFilter: $primaryFilter
      filters: $filters
      sortFields: $sortFields
    ) {
      id
      name
      primaryFilter
      filters {
        key
        values
      }
      sortFields {
        sortBy
        direction
      }
      isDefault
      createdAt
    }
  }
`;

export const FULL_UPDATE_SAVED_VIEW = gql`
  mutation FullUpdateSavedView(
    $courierId: ID!
    $id: ID!
    $name: String!
    $primaryFilter: String
    $filters: [SavedViewFilterInput!]!
    $sortFields: [SavedViewSortInput!]!
  ) {
    fullUpdateSavedView(
      courierId: $courierId
      id: $id
      name: $name
      primaryFilter: $primaryFilter
      filters: $filters
      sortFields: $sortFields
    ) {
      id
      name
      primaryFilter
      filters {
        key
        values
      }
      sortFields {
        sortBy
        direction
      }
      isDefault
      createdAt
    }
  }
`;

export const DELETE_SAVED_VIEW = gql`
  mutation DeleteSavedView(
    $courierId: ID!
    $userOrEmployeeId: ID!
    $savedViewId: ID!
  ) {
    deleteSavedView(
      courierId: $courierId
      userOrEmployeeId: $userOrEmployeeId
      savedViewId: $savedViewId
    )
  }
`;

export const SET_DEFAULT_SAVED_VIEW = gql`
  mutation SetDefaultSavedView(
    $courierId: ID!
    $userOrEmployeeId: ID!
    $page: SavedViewPage!
    $savedViewId: ID!
  ) {
    setDefaultSavedView(
      courierId: $courierId
      userOrEmployeeId: $userOrEmployeeId
      page: $page
      savedViewId: $savedViewId
    )
  }
`;
